import { BRAND } from "../lib/content";

// Vintage tattoo-flash spider-web corners on the four corners of a section.
export const CornerWebs = ({ className = "" }) => (
  <div aria-hidden="true" className={`pointer-events-none absolute inset-0 z-0 ${className}`}>
    <img src={BRAND.web} alt="" className="absolute left-0 top-0 w-16 opacity-40 md:w-24" />
    <img src={BRAND.web} alt="" className="absolute right-0 top-0 w-16 -scale-x-100 opacity-40 md:w-24" />
    <img src={BRAND.web} alt="" className="absolute bottom-0 left-0 w-16 -scale-y-100 opacity-40 md:w-24" />
    <img src={BRAND.web} alt="" className="absolute bottom-0 right-0 w-16 -scale-100 opacity-40 md:w-24" />
  </div>
);
